/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-29 11:09:06
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-29 11:09:45
 */
import Vue from 'vue'
import hasPermi from './permission/hasPermi'

const install = function (Vue) {
  Vue.directive('hasPermi', hasPermi)
}

if (window.Vue) {
  Vue.use(install)
}

export default install
